import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Alert, Button, List, Modal, Progress, Result } from 'antd';
import { mapReducer } from 'core/utils/store';
import { useEffect, useMemo, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SettingsEntityDeleteModal(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = useState(false),
      isDeleting = _useState2[0],
      setDeleting = _useState2[1];

  var _useReducer = useReducer(mapReducer, {}),
      statuses = _useReducer[0],
      dispatchStatus = _useReducer[1];

  var itemsToProcess = useMemo(function () {
    var result = [];

    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _statuses$item$id, _statuses$item$id2;

        var item = _step.value;

        if (!((_statuses$item$id = statuses[item.id]) !== null && _statuses$item$id !== void 0 && _statuses$item$id.active) || (_statuses$item$id2 = statuses[item.id]) !== null && _statuses$item$id2 !== void 0 && _statuses$item$id2.error) {
          result.push(item);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  }, [statuses]);
  var hasFinished = useMemo(function () {
    return !Object.values(statuses).some(function (status) {
      return !status.finished;
    });
  }, [statuses]);
  var hasErrors = useMemo(function () {
    return Object.values(statuses).some(function (status) {
      return !!status.error;
    });
  }, [statuses]);
  var canDeleteMore = useMemo(function () {
    return !hasFinished || hasErrors;
  }, [hasFinished, hasErrors]);

  function startDeleting() {
    return _startDeleting.apply(this, arguments);
  }

  function _startDeleting() {
    _startDeleting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setDeleting(true);
              _context.next = 3;
              return Promise.all(itemsToProcess.map(function (item) {
                return deleteItem(item);
              }));

            case 3:
              setDeleting(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _startDeleting.apply(this, arguments);
  }

  function deleteItem(_x) {
    return _deleteItem.apply(this, arguments);
  }

  function _deleteItem() {
    _deleteItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatchStatus({
                type: 'addOne',
                key: item.id,
                value: {
                  progress: 50,
                  active: true
                }
              });
              _context2.prev = 1;
              _context2.next = 4;
              return props.deleteItem(item.id);

            case 4:
              dispatchStatus({
                type: 'addOne',
                key: item.id,
                value: {
                  progress: 100,
                  active: true,
                  finished: true,
                  success: true
                }
              });
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              dispatchStatus({
                type: 'addOne',
                key: item.id,
                value: {
                  progress: 50,
                  active: true,
                  finished: true,
                  error: true
                }
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));
    return _deleteItem.apply(this, arguments);
  }

  useEffect(function () {
    if (props.isVisible) {
      setItems(props.items);
      var newStatuses = {};

      var _iterator2 = _createForOfIteratorHelper(props.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          newStatuses[item === null || item === void 0 ? void 0 : item.id] = {
            progress: 0
          };
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      dispatchStatus({
        type: 'addMany',
        items: newStatuses,
        clear: true
      });
    }
  }, [props.isVisible]);
  return /*#__PURE__*/_jsxs(Container, {
    title: t("settings.".concat(props.entity, ".deleteMany.title"), {
      quantity: items.length
    }),
    open: props.isVisible,
    onCancel: function onCancel() {
      return !isDeleting && props.onCancel();
    },
    closable: !isDeleting,
    footer: [/*#__PURE__*/_jsx(Button, {
      type: "text",
      onClick: function onClick() {
        return !isDeleting && props.onCancel();
      },
      disabled: isDeleting,
      children: t('close')
    }, "cancel"), canDeleteMore && /*#__PURE__*/_jsx(Button, {
      type: "primary",
      danger: true,
      onClick: startDeleting,
      disabled: isDeleting,
      children: t("settings.".concat(props.entity, ".deleteMany.title"), {
        quantity: isDeleting ? items.length : itemsToProcess.length
      })
    }, "submit")],
    children: [/*#__PURE__*/_jsx(Alert, {
      message: t('warning'),
      description: t("settings.".concat(props.entity, ".deleteMany.warning")),
      type: "warning",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
      bordered: true,
      dataSource: items,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(ListItem, {
          item: item,
          status: statuses[item.id]
        });
      }
    }), hasFinished && /*#__PURE__*/_jsx(Result, {
      status: hasErrors ? 'error' : 'success',
      title: hasErrors ? t("settings.".concat(props.entity, ".deleteMany.error")) : t("settings.".concat(props.entity, ".deleteMany.success")),
      subTitle: hasErrors && t('unknownError')
    })]
  });
}

function ListItem(props) {
  var _props$status$progres, _props$status3, _props$status4;

  var progressStatus = useMemo(function () {
    var _props$status, _props$status2;

    if ((_props$status = props.status) !== null && _props$status !== void 0 && _props$status.error) {
      return 'exception';
    }

    if ((_props$status2 = props.status) !== null && _props$status2 !== void 0 && _props$status2.success) {
      return 'success';
    }
  }, [props.status]);
  return /*#__PURE__*/_jsxs(List.Item, {
    className: "list-item",
    children: [/*#__PURE__*/_jsx("span", {
      className: "item-name",
      children: props.item.name
    }), /*#__PURE__*/_jsx(Progress, {
      type: "circle",
      percent: (_props$status$progres = (_props$status3 = props.status) === null || _props$status3 === void 0 ? void 0 : _props$status3.progress) !== null && _props$status$progres !== void 0 ? _props$status$progres : 0,
      width: 24,
      showInfo: !!((_props$status4 = props.status) !== null && _props$status4 !== void 0 && _props$status4.active),
      status: progressStatus
    })]
  });
}

var Container = styled(Modal).withConfig({
  displayName: "SettingsEntityDeleteModal__Container",
  componentId: "sc-18sgxy8-0"
})([".item-row{width:100%;}"]);